import { MaxDailyInRange } from '../../utils/arrayUtils';

/**
 * Dia com mais vendas dentro do período ABSOLUTO (não "últimos N dias até hoje").
 * Devolve { qty, dateIso } ou null se tudo for 0.
 */
export function BestDay(dailyByDate, ctx) {
    if (!ctx?.periodStartIso || !ctx?.periodEndIso) return null;
    const result = MaxDailyInRange(dailyByDate, ctx.periodStartIso, ctx.periodEndIso);
    if (!result) return null;
    return { qty: result.qty, dateIso: result.date };
}
